import { Link } from "react-router-dom";
import { Calculator, ArrowRight } from "lucide-react";
import { scrollToId } from "@/lib/api";

export default function CalcBanner({ context = "" }) {
  const suffix = context ? `-${context}` : "";
  return (
    <div className="border border-gold/40 bg-gold/5 p-6 md:p-8 flex flex-col sm:flex-row items-center justify-between gap-5"
      data-testid={`calc-banner${suffix}`}>
      <div>
        <p className="font-mono2 text-gold uppercase tracking-[0.3em] text-xs mb-2">Zadarmo · do 60 sekúnd</p>
        <h3 className="font-display text-2xl md:text-3xl text-white">Koľko bude stáť vaše zateplenie?</h3>
        <p className="text-white/60 text-sm mt-1">Cena na kľúč — materiál, práca, lešenie aj doprava. Bez záväzkov.</p>
      </div>
      <Link to="/#kalkulacka" onClick={() => setTimeout(() => scrollToId("#kalkulacka"), 60)}
        data-testid={`calc-banner-cta${suffix}`}
        className="shrink-0 bg-gold text-ink px-7 py-3.5 font-bold uppercase tracking-wider hover:bg-gold-light transition-colors flex items-center gap-2">
        <Calculator className="w-4 h-4" /> Vypočítať cenu <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
}
